import { Injectable } from '@angular/core';
import { EndpointConfig } from '../common/EndpointConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SaveColourRequest, SaveComplainRequest, SaveCountryRequest, SaveFuelTypeRequest, SaveGBrandRequest, SaveGCustomerRequest, SaveGItemDefinintionAttachmentRequest, SaveGVehicleRequest, SaveGWarehouseRequest, SaveItemRequest, SaveItemsByWarehouseRequest, SaveManufacturerRequest, SavePackageRequest, SavePackageTypeRequest, SaveSSCategoryRequest, SaveTagRequest, SaveTagTypeRequest, SaveUnitRequest, SaveVehicleModelRequest, SaveVehicleNotifyRequest, SaveVehicleStatusRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Injectable({
  providedIn: 'root'
})
export class GsettingService {

  private _ep: EndpointConfig;
  constructor(private http: HttpClient) {
    this._ep = new EndpointConfig('');
  }

  public GetAccountsBySearchAsync(type: string) {
    return this.http.get(`${this._ep.getControllerUrl('Account', 'GetAccountsBySearchAsync')}/${type}`);
  }

  public LoadAccountFormAsync() {
    return this.http.get(`${this._ep.getControllerUrl('Account', 'LoadAccountFormAsync')}`);
  }

  public GetFuelTypesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetFuelTypesAsync')}`);
  }

  public DeleteFuelTypeAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteFuelTypeAsync')}/${id}`);
  }

  public SaveFuelTypeAsync(obj: SaveFuelTypeRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveFuelTypeAsync')}`, obj);
  }


  public GetGBrandsAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGBrandsAsync')}`);
  }

  public DeleteGBrandAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteGBrandAsync')}/${id}`);
  }

  public SaveGBrandAsync(obj: SaveGBrandRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGBrandAsync')}`, obj);
  }


  public GetManufacturersAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetManufacturersAsync')}`);
  }

  public DeleteManufacturerAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteManufacturerAsync')}/${id}`);
  }

  public SaveManufacturerAsync(obj: SaveManufacturerRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveManufacturerAsync')}`, obj);
  }


  public GetTagTypesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetTagTypesAsync')}`);
  }

  public DeleteTagTypesAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteTagTypesAsync')}/${id}`);
  }

  public SaveTagTypeAsync(obj: SaveTagTypeRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveTagTypeAsync')}`, obj);
  }


  public GetPackageTypesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetPackageTypesAsync')}`);
  }

  public DeletePackageTypesAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeletePackageTypesAsync')}/${id}`);
  }

  public SavePackageTypeAsync(obj: SavePackageTypeRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SavePackageTypeAsync')}`, obj);
  }


  public GetUnitsAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetUnitsAsync')}`);
  }

  public DeleteUnitAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteUnitAsync')}/${id}`);
  }

  public SaveUnitAsync(obj: SaveUnitRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveUnitAsync')}`, obj);
  }


  public GetColoursAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetColoursAsync')}`);
  }

  public DeleteColourAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteColourAsync')}/${id}`);
  }

  public SaveColourAsync(obj: SaveColourRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveColourAsync')}`, obj);
  }


  public GetComplainsAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetComplainsAsync')}`);
  }

  public DeleteComplainAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteComplainAsync')}/${id}`);
  }

  public SaveComplainAsync(obj: SaveComplainRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveComplainAsync')}`, obj);
  }


  public GetVehicleStatusesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetVehicleStatusesAsync')}`);
  }

  public DeleteVehicleStatusAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteVehicleStatusAsync')}/${id}`);
  }

  public SaveVehicleStatusAsync(obj: SaveVehicleStatusRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveVehicleStatusAsync')}`, obj);
  }


  public GetCountriesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('Setting', 'GetCountriesAsync')}`);
  }

  public DeleteCountryAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('Setting', 'DeleteCountryAsync')}/${id}`);
  }

  public SaveCountryAsync(obj: SaveCountryRequest) {
    debugger
    const formData = new FormData();
    formData.append('Country', JSON.stringify(obj));
    // Send FormData instead of JSON
    return this.http.post(
      `${this._ep.getControllerUrl('Setting', 'SaveCountryAsync')}`,
      formData
    );
  }


  public GetVehicleModelsAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetVehicleModelsAsync')}`);
  }

  public DeleteVehicleModelAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteVehicleModelAsync')}/${id}`);
  }

  public SaveVehicleModelAsync(obj: SaveVehicleModelRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveVehicleModelAsync')}`, obj);
  }


  public GetSSCategoriesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetSSCategoriesAsync')}`);
  }

  public DeleteSSCategoryAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteSSCategoryAsync')}/${id}`);
  }

  public SaveSSCategoryAsync(obj: SaveSSCategoryRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveSSCategoryAsync')}`, obj);
  }

  public GetItemTypesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemTypesAsync')}`);
  }


  public GetTagsAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetTagsAsync')}`);
  }

  public DeleteTagAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteTagAsync')}/${id}`);
  }

  public SaveTagAsync(obj: SaveTagRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveTagAsync')}`, obj);
  }


  public DeleteGCustomerAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteGCustomerAsync')}/${id}`);
  }

  public GetCountryCodesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetCountryCodesAsync')}`);
  }


  public GetGCustomersDropDownAsync(flag: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGCustomersDropDownAsync')}/${flag}`);
  }

  public SaveGCustomerAsync(obj: SaveGCustomerRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGCustomerAsync')}`, obj);
  }

  public SyncItemWarehouseAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'SyncItemWarehouseAsync')}`);
  }

  public DeleteGVehicleAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteGVehicleAsync')}/${id}`);
  }

  public GetGVehiclesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGVehiclesDropDownAsync')}`);
  }

  public GetGVehiclesByUserAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGVehiclesByUserAsync')}`);
  }

   public GetGVehicleByIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGVehicleByIdAsync')}/${id}`);
  }

  public LoadVehicleFormAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'LoadVehicleFormAsync')}`);
  }

  public SaveGVehicleAsync(obj: SaveGVehicleRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGVehicleAsync')}`, obj);
  }

  public GetGVehiclesExportAsync(id: number, fromDate: Date | string, toDate: Date | string) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];

    return this.http.get(
      `${this._ep.getControllerUrl('GSetting', 'GetGVehiclesExportAsync')}/${id}/${encodeURIComponent(f)}/${encodeURIComponent(t)}`
    );
  }


  public DeleteVehicleNotifyAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteVehicleNotifyAsync')}/${id}`);
  }

  public LoadVehicleNotifyFormAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'LoadVehicleNotifyFormAsync')}/${id}`);
  }

  public GetVehicleNotifyExportAsync(fromDate: Date | string, toDate: Date | string) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];

    return this.http.get(
      `${this._ep.getControllerUrl('GSetting', 'GetVehicleNotifyExportAsync')}/${encodeURIComponent(f)}/${encodeURIComponent(t)}`
    );
  }

  public SaveVehicleNotifyAsync(obj: SaveVehicleNotifyRequest) {
    debugger
    const formData = new FormData();
    if (obj.file != undefined) {
      for (var i = 0; i < obj.file.length; i++) {
        formData.append('file', obj.file[i]);
      }
    }
    formData.append('Vehicle', JSON.stringify(obj));
    // Send FormData instead of JSON
    return this.http.post(
      `${this._ep.getControllerUrl('GSetting', 'SaveVehicleNotifyAsync')}`,
      formData
    );
  }


  public LoadItemFormAsync(newCode: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'LoadItemFormAsync')}/${newCode}`);
  }

  public SaveItemAsync(obj: SaveItemRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveItemAsync')}`, obj);
  }

  SaveItemFromExcelAsync(obj){
  const formData = new FormData();
  formData.append("file", obj.file);
  return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveItemFromExcelAsync')}`, formData);
}

  UpdateItemFromExcelAsync(obj){
  const formData = new FormData();
  formData.append("file", obj.file);
  return this.http.post(`${this._ep.getControllerUrl('GSetting', 'UpdateItemFromExcelAsync')}`, formData);
}

  public GetItemsExportAsync(flag: string, fromDate: Date | string, toDate: Date | string) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];
    return this.http.get(
      `${this._ep.getControllerUrl('GSetting', 'GetItemsExportAsync')}/${flag}/${encodeURIComponent(f)}/${encodeURIComponent(t)}`
    );
  }

   public DownloadItemExcelAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'DownloadItemExcelAsync')}`);
  }

  public GetWareHouseItemsAsync(id: number) {
    return this.http.get(
      `${this._ep.getControllerUrl('GSetting', 'GetWareHouseItemsAsync')}/${id}`
    );
  }

  public SaveWareHouseItemsAsync(obj: any) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveWareHouseItemsAsync')}`, obj);
  }

  public GetItemAttachmentsAsync(id: number) {
    return this.http.get(
      `${this._ep.getControllerUrl('GSetting', 'GetItemAttachmentsAsync')}/${id}`
    );
  }

  

  SaveGItemAttachmentAsync(obj: SaveGItemDefinintionAttachmentRequest) {

    let fd = new FormData();
    debugger
    if (obj.itemFiles != undefined) {
      for (var i = 0; i < obj.itemFiles.length; i++) {
        fd.append('ItemFiles', obj.itemFiles[i]);
      }
    }
    if (obj.categoryFile != undefined) {
      for (var i = 0; i < obj.categoryFile.length; i++) {
        fd.append('CategoryFile', obj.categoryFile[i]);
      }
    }
    fd.append('Item', JSON.stringify(obj));
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGItemAttachmentAsync')}`, fd);
  }

  public DeleteItemAttachmentAsync(id: number) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteItemAttachmentAsync')}/${id}`);
  }

  public MarkItemAttachmentPrimaryAsync(id: number, idd: number, type: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'MarkItemAttachmentPrimaryAsync')}/${id}/${idd}/${type}`);
  }

  public DeletePackageAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeletePackageAsync')}/${id}`);
  }

   public GetPackageByModelIdAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetPackageByModelIdAsync')}/${id}`);
  }

  public GetItemsDropDownByTypeAsync(type: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsDropDownByTypeAsync')}/${type}`);
  }

  public GetItemsDropDownByWarehouseIdAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsDropDownByWarehouseIdAsync')}/${id}`);
  }

  public GetItemsDropDownByWarehouseAndSupplierIdAsync(modelId: number, typeId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsDropDownByWarehouseAndSupplierIdAsync')}/${modelId}/${typeId}`);
  }

  public GetItemsDropDownByModelAndTypeIdAsync(supId: number, warId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsDropDownByModelAndTypeIdAsync')}/${supId}/${warId}`);
  }

  public SavePackageAsync(obj: SavePackageRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SavePackageAsync')}`, obj);
  }



  public GetGWarehousesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetGWarehousesAsync')}`);
  }

  public DeleteGWarehouseAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteGWarehouseAsync')}/${id}`);
  }

  public SaveGWarehouseAsync(obj: SaveGWarehouseRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGWarehouseAsync')}`, obj);
  }

  public GetItemsByWarehouseAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsByWarehouseAsync')}/${id}`);
  }

  public SaveItemsByWarehouseAsync(obj: any) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveItemsByWarehouseAsync')}`, obj);
  }

  public GetItemsByWarehouseExcelAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetItemsByWarehouseExcelAsync')}/${id}`);
  }

  SaveItemsByWarehouseByExcelAsync(obj: SaveItemsByWarehouseRequest) {
    debugger
    const formData = new FormData();
    formData.append("file", obj.file);
    formData.append("Item", JSON.stringify(obj));
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveItemsByWarehouseByExcelAsync')}`, formData);
  }

  public GetHeaderFootersDropDownAsync() {
    return this.http.get(`${this._ep.getControllerUrl('Setting', 'GetHeaderFootersDropDownAsync')}`);
  }

  public GetUserWarehouseAsync(userWarehouse: number) {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetUserWarehouseAsync')}/${userWarehouse}`);
  }

  public GetPurchaseRequisiteDropDownAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetPurchaseRequisiteDropDownAsync')}`);
  }

public GetGQuotationNotesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGQuotationNotesAsync')}`);
  }


  public getList(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = 'Desc',
    sort: string = '',
    flag: string = ''
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    if (flag !== undefined && flag !== null && flag !== '') {
      params = params.set('Flag', flag.toString());
    }

    // Use Object.keys to iterate over the properties of searchObj
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }



  public getListById(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = '',
    sort: string = '',
    id?: string | number // add Id param here, optional
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    // Add Id if provided
    if (id !== undefined && id !== null && id !== '') {
      params = params.set('Id', id.toString());
    }

    // Use Object.keys to iterate over searchObj properties
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }


}
